export enum PriceTableContextName {
  EcommPricingTable = 'ecommPricingTable',
  ProductExpansionPricingTable = 'productExpansionPricingTable',
  PriceNavigatorDashboard = 'priceNavigatorDashboard',
}
